module.exports = __webpack_public_path__ + "static/media/im_3.920c41c5.JPG";